"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
require("./projects.scss");
var BeautyCard_1 = require("./components/BeautyCard");
var ccLogoAlt_png_1 = __importDefault(require("../../../Assets/illustrator-imgs/ccLogoAlt.png"));
var biruk_website_svg_1 = __importDefault(require("../../../Assets/illustrator-imgs/biruk_website.svg"));
var menuCardsPositive1_png_1 = __importDefault(require("../../../Assets/illustrator-imgs/menuCardsPositive1.png"));
var accordion_slider_codepen_jpg_1 = __importDefault(require("../../../Assets/codepen-imgs/accordion-slider_codepen.jpg"));
var color_chooser_codepen_jpg_1 = __importDefault(require("../../../Assets/codepen-imgs/color-chooser_codepen.jpg"));
var gallery_image_codepen_jpg_1 = __importDefault(require("../../../Assets/codepen-imgs/gallery-image_codepen.jpg"));
var Projects = /** @class */ (function (_super) {
    __extends(Projects, _super);
    function Projects() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Projects.prototype.render = function () {
        return (react_1.default.createElement("div", { className: 'project-container' },
            react_1.default.createElement("div", { className: 'project-beauty-container' },
                react_1.default.createElement(BeautyCard_1.BeautyCard, { className: 'cards-option', label: 'Codepen  ' },
                    react_1.default.createElement("div", { className: 'image-class beauty-card', id: 'acc-img' },
                        react_1.default.createElement("a", { className: 'img-links', target: '_blank', href: "https://codepen.io/biruktesfayeve/pen/ZmpEWV" }, "open pen ")),
                    react_1.default.createElement("div", { className: 'image-class beauty-card', id: 'col-img' },
                        react_1.default.createElement("a", { className: 'img-links', target: '_blank', href: "https://codepen.io/biruktesfayeve/pen/bmwWbx" }, "open pen ")),
                    react_1.default.createElement("div", { className: 'image-class beauty-card', id: 'gal-img' },
                        react_1.default.createElement("a", { className: 'img-links', target: '_blank', href: "https://codepen.io/biruktesfayeve/pen/EdgMEL" }, "open pen "))),
                react_1.default.createElement(BeautyCard_1.BeautyCard, { className: 'cards-option', label: 'Illustrations ' },
                    react_1.default.createElement("div", { className: 'beauty-card  ill-class', id: 'cc_logo' }),
                    react_1.default.createElement("div", { className: 'beauty-card  ill-class', id: 'mock_up' }),
                    react_1.default.createElement("div", { className: 'beauty-card  ill-class', id: 'card_logo' })),
                react_1.default.createElement("div", { className: 'optional-div-container' },
                    react_1.default.createElement("a", { className: 'img-links', target: '_blank', href: "https://codepen.io/biruktesfayeve/pen/ZmpEWV" },
                        react_1.default.createElement("img", { src: accordion_slider_codepen_jpg_1.default, alt: "" })),
                    react_1.default.createElement("a", { className: 'img-links', target: '_blank', href: "https://codepen.io/biruktesfayeve/pen/bmwWbx" },
                        react_1.default.createElement("img", { src: color_chooser_codepen_jpg_1.default, alt: "" })),
                    react_1.default.createElement("a", { className: 'img-links', target: '_blank', href: "https://codepen.io/biruktesfayeve/pen/EdgMEL" },
                        react_1.default.createElement("img", { src: gallery_image_codepen_jpg_1.default, alt: "" })),
                    react_1.default.createElement("a", { className: 'img-links', target: '_blank', href: "https://codepen.io/biruktesfayeve/pen/ZmpEWV" },
                        react_1.default.createElement("img", { src: menuCardsPositive1_png_1.default, alt: "" })),
                    react_1.default.createElement("a", { className: 'img-links', target: '_blank', href: "https://codepen.io/biruktesfayeve/pen/ZmpEWV" },
                        react_1.default.createElement("img", { src: biruk_website_svg_1.default, alt: "" })),
                    react_1.default.createElement("a", { className: 'img-links', target: '_blank', href: "https://codepen.io/biruktesfayeve/pen/ZmpEWV" },
                        react_1.default.createElement("img", { src: ccLogoAlt_png_1.default, alt: "" }))))));
    };
    return Projects;
}(react_1.Component));
exports.Projects = Projects;



//////////////////
// WEBPACK FOOTER
// ./src/App/components/Peojects/Projects.tsx
// module id = 74
// module chunks = 0